import React, { useEffect, useRef } from "react";
import { useAppDispatch } from "../../redux/hooks";

// WEBSOCKET
import { wsEndpoint } from "../../api/endpoints";
import { useParams } from "react-router-dom";
import {
  updateFloorData,
  updateDeskStatus,
  updateDeskData,
  updateDeskInfoOnUnassignSensor,
  updateDeskInfoOnAssignSensor,
  updateNumberOfUnavailableDesks,
  updateSyncFlag,
} from "../../redux/slices/groups.slice";

import {
  setFileLink,
  updateFloorStats,
} from "../../redux/slices/reports.slice";
import useManagedSignalingConnection from "../../hooks/useManagedSignalingConnection";

export function StateHandler() {
  const dispatch = useAppDispatch();
  const { id } = useParams();

  const onSignalingHandlerRef = useRef<(msg: any) => void>(() => null);
  const { isOpen, connectionCount, sendToServer } =
    useManagedSignalingConnection({
      socketURL: wsEndpoint,
      onMessage: (message) => onSignalingHandlerRef.current(message),
    });

  useEffect(() => {
    if (!id || !isOpen) {
      return;
    }

    sendToServer({
      action: "subscribe",
      floorID: id,
      type: "location",
    });
  }, [id, isOpen, connectionCount, dispatch, sendToServer]);

  onSignalingHandlerRef.current = (msg: any) => {
    switch (msg.action) {
      case "dataSummary": {
        dispatch(updateFloorData(msg.payload));

        break;
      }
      case "deskData": {
        dispatch(updateDeskData(msg.payload));
        break;
      }
      case "sync-success": {
        dispatch(updateSyncFlag({ flag: "SUCCEEDED" }));
        break;
      }
      case "sync-failed": {
        dispatch(updateSyncFlag({ flag: "FAILED" }));
        break;
      }
      case "desk-status-update": {
        dispatch(updateDeskStatus(msg.payload));
        dispatch(updateNumberOfUnavailableDesks(msg.payload));
        break;
      }
      case "desk-assign-sensor": {
        dispatch(updateDeskInfoOnAssignSensor(msg.payload));

        break;
      }
      case "desk-unassign-sensor": {
        dispatch(updateDeskInfoOnUnassignSensor(msg.payload));
        break;
      }
      case "wsSubscribe":
        if (
          !sendToServer({
            action: "subscribe",
            locationID: msg.locationID,
          })
        ) {
          console.warn(
            "Attempting to send message via websocket which hasnt been instantiated",
          );
        }
        break;
      case "wsHeartbeat":
        if (!sendToServer({ action: "heartbeat" })) {
          console.error(
            "Attempting to send heartbeat message via websocket which hasnt been instantiated",
          );
        }
        break;
      case "file-link": {
        dispatch(setFileLink(msg.payload));
        break;
      }
      case "statisticsSummary": {
        dispatch(updateFloorStats(msg.payload));
        break;
      }
    }
  };

  return <></>;
}

export default StateHandler;
